module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/DailyPrecipitation0/Nagano_DailyPrecipitation0_MRI_RCP85_End.png";